import { API_BASE } from "../../config.js";
import { state } from "../../state/store.js";

const mediaUrlCache = new Map();
const mediaInflight = new Map();

export async function getMediaObjectUrl(messageId) {
  const cached = mediaUrlCache.get(messageId);
  if (cached) return cached.url;
  if (mediaInflight.has(messageId)) return mediaInflight.get(messageId);

  const url = await fetch(`${API_BASE}/whatsapp/messages/${messageId}/media`, {
    headers: { Authorization: `Bearer ${state.authToken}` },
  }).then(async (resp) => {
    if (!resp.ok) {
      let detail = `HTTP ${resp.status}`;
      try { detail = (await resp.json()).detail || detail; } catch (_) { /* noop */ }
      throw new Error(detail);
    }
    const blob = await resp.blob();
    return URL.createObjectURL(blob);
  });

  const promise = Promise.resolve(url).then((value) => {
    mediaUrlCache.set(messageId, { url: value, expiresAt: Date.now() + 30 * 60 * 1000 });
    mediaInflight.delete(messageId);
    return value;
  });
  mediaInflight.set(messageId, promise);
  return promise;
}

export async function getMediaForDownload(messageId, fallbackName = "") {
  const resp = await fetch(`${API_BASE}/whatsapp/messages/${messageId}/media`, {
    headers: { Authorization: `Bearer ${state.authToken}` },
    cache: "reload",
  });
  if (!resp.ok) {
    let detail = `HTTP ${resp.status}`;
    try { detail = (await resp.json()).detail || detail; } catch (_) { /* noop */ }
    throw new Error(detail);
  }
  const serverFilename = getContentDispositionFilename(resp.headers.get("content-disposition") || "");
  const blob = await resp.blob();
  const url = URL.createObjectURL(blob);
  return { url, filename: serverFilename || fallbackName, mime: resp.headers.get("content-type") || "" };
}

function getContentDispositionFilename(contentDisposition) {
  if (!contentDisposition) return "";
  let match = contentDisposition.match(/filename\*=(?:UTF-8'')?"?([^";\r\n]+)"?/i);
  if (!match) match = contentDisposition.match(/filename="?([^";\r\n]+)"?/i);
  if (!match) return "";
  try {
    return decodeURIComponent(match[1]).trim();
  } catch (_) {
    return match[1].trim();
  }
}
